import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import ProductCard from "../components/ProductCard";
import TrustStrip from "../components/TrustStrip";
import { allProducts, bestSellers, topOffers, categories, homeTrust } from "../mock";
import { fetchProducts } from "../api";

const CategoryDetail = ({ offers = false }) => {
  const { slug } = useParams();
  const cat = categories.find((c) => c.slug === slug);
  const title = offers ? "Top Offers" : cat?.name || "All Products";
  const bg = offers ? "#fdf1e2" : cat?.bg || "#e8f6ec";
  const color = offers ? "#c2570c" : cat?.color || "#0e7a3d";

  const buildFallback = () => {
    if (offers) return topOffers;
    const own = allProducts.filter((p) => p.category === slug);
    const fill = bestSellers.filter((p) => !own.some((o) => o.id === p.id));
    return [...own, ...fill].slice(0, 8);
  };

  const [prods, setProds] = useState(buildFallback);

  useEffect(() => {
    let mounted = true;
    const params = offers ? { section: "offers" } : { category: slug };
    fetchProducts(params)
      .then((d) => {
        if (!mounted) return;
        setProds(d?.length ? d : buildFallback());
      })
      .catch(() => mounted && setProds(buildFallback()));
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, offers]);

  return (
    <div className="min-h-screen bg-white">
      <Header variant="home" />
      <Navbar />

      <div style={{ backgroundColor: bg }} className="py-6 sm:py-8">
        <div className="max-w-[1400px] mx-auto px-3 lg:px-4">
          <div className="flex items-center gap-1.5 text-[11.5px] text-gray-500 mb-1.5">
            <Link to="/" className="hover:text-[#0e7a3d]">Home</Link>
            <ChevronRight size={12} />
            {!offers && (
              <>
                <Link to="/categories" className="hover:text-[#0e7a3d]">
                  Categories
                </Link>
                <ChevronRight size={12} />
              </>
            )}
            <span className="font-semibold text-gray-700">{title}</span>
          </div>
          <h1 className="text-[24px] sm:text-[30px] font-extrabold" style={{ color }}>
            {title}
          </h1>
          <p className="text-[12.5px] text-gray-600 mt-1">
            {prods.length} products · 100% genuine · Fast delivery
          </p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-3 lg:px-4 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3.5">
          {prods.map((p) => (
            <ProductCard key={p.id} p={p} />
          ))}
        </div>
      </div>

      <TrustStrip items={homeTrust} cols={4} />
    </div>
  );
};

export default CategoryDetail;
